import { DisplayDecorator, JsonDisplayDecorator } from '../../decorators/display-decorator';
import { ODataObject } from '../../interfaces/odata-model.interface';
import { CustomInjector } from '../../services/custom-injector/custom-injector';
import { ModelOptionsLoaderService } from '../../services/model-options-loader/model-options-loader.service';
import { CompositeModel } from '../complex/composite.model';
import { BooleanModelOptions } from '../options/boolean-model-options';
import { BooleanModel } from '../primitive/boolean.model';
import { JsonTextModel, TextModel } from '../primitive/text.model';
import { DataMaintenanceUtilities } from '../../utilities/data-maintenance-utilities';

export class RecipientModel extends CompositeModel {
    public faxEmail: TextModel;
    public commCategory: TextModel;
    public isSelected: DisplayDecorator<BooleanModel>;
    public isEditable: boolean;
    public isDeletable: boolean;
    public isHidden: boolean;
    public isFromEmailSet: boolean;
    public isSubmitted: boolean;
    public constructor(
        faxEmail: string,
        commCategory: string,
        isSelected = true,
        isEditable = false,
        isDeletable = false,
        isHidden = false,
        isFromEmailSet = true,
        isSubmitted = false,
    ) {
        super('RecipientModel', {});

        const injector = CustomInjector.getInjector();
        const modelOptionsLoader = injector.get(ModelOptionsLoaderService);
        const dataMaintenanceUtilities = injector.get(DataMaintenanceUtilities);

        this.faxEmail = <TextModel>this.set(new TextModel('FaxEmail', faxEmail));
        modelOptionsLoader.load(this.faxEmail, 'ServiceReport', 'FaxEmail');

        this.faxEmail.options = {
            ...this.faxEmail.options,
            readonly: !isSelected,
        };

        this.commCategory = <TextModel>this.set(new TextModel('CommCategory', commCategory));
        const isSelectable = !dataMaintenanceUtilities.isEmailInvalid(
            this.faxEmail.value,
            this.faxEmail.options.pattern,
        );
        this.isSelected = new DisplayDecorator<BooleanModel>(
            '',
            new BooleanModel(
                'IsSelected',
                isSelectable && isSelected,
                new BooleanModelOptions({ disabled: !isSelectable, showLabel: false }),
            ),
        );
        modelOptionsLoader.load(this.isSelected, 'ServiceReport', 'IsSelected');
        this.isEditable = isEditable;
        this.isDeletable = isDeletable;
        this.isHidden = isHidden;
        this.isFromEmailSet = isFromEmailSet;
        this.isSubmitted = isSubmitted;
    }

    /**
     * Creates an empty model for delete recipient action
     */
    public emptyModel(): void {
        this.isHidden = true;
        this.faxEmail.value = '';
        this.commCategory.value = '';
    }

    public getOutModel(): ODataRecipientOutModel {
        return <ODataRecipientOutModel>super.getOutModel();
    }
}

export class RecipientModelFromJson extends RecipientModel {
    public constructor(data: JsonRecipientModel) {
        super(
            data.faxEmail.value,
            data.commCategory.value,
            <boolean>data.isSelected.model.value,
            data.isEditable,
            data.isDeletable,
            data.isHidden,
            data.isFromEmailSet,
            data.isSubmitted,
        );
    }
}

export interface JsonRecipientModel {
    faxEmail: JsonTextModel;
    commCategory: JsonTextModel;
    isSelected: JsonDisplayDecorator;
    isEditable: boolean;
    isDeletable: boolean;
    isHidden: boolean;
    isFromEmailSet: boolean;
    isSubmitted: boolean;
}

export interface ODataRecipientOutModel extends ODataObject {
    FaxEmail: string;
    CommCategory: string;
}
